import './index.css';

const expectedPassword = import.meta.env.VITE_DEVTOOLS_PASSWORD;
if (!expectedPassword) throw new Error('Missing VITE_DEVTOOLS_PASSWORD');

window.addEventListener('beforeunload', () => {
  sessionStorage.removeItem('devtools_passed');
});

document.addEventListener('keydown', (e) => {
  if (
    e.key === 'F12' ||
    e.keyCode === 123 ||
    (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) ||
    (e.ctrlKey && e.key.toLowerCase() === 'u')
  ) {
    e.preventDefault();
  }
});

document.addEventListener('contextmenu', (e) => {
  e.preventDefault();
});

function isDevToolsOpen() {
  const isDesktop = navigator.maxTouchPoints === 0;

  if (!isDesktop) return false;

  const threshold = 160;
  return (
    window.outerWidth - window.innerWidth > threshold ||
    window.outerHeight - window.innerHeight > threshold
  );
}

function showPasswordModal(onSubmit) {
  if (document.getElementById('devtools-pass-modal')) return;

  const modal = document.createElement('div');
  modal.id = 'devtools-pass-modal';
  modal.style = `
    position: fixed;
    top: 0; left: 0; width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.7);
    display: flex; justify-content: center; align-items: center;
    z-index: 9999;
  `;

  modal.innerHTML = `
    <style>
      #pw-input {
        padding: 10px;
        width: 100%;
        border: 2px solid orange;
        border-radius: 4px;
        outline: none;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
      }

      #pw-input:focus {
        border-color: darkorange;
        box-shadow: 0 0 5px rgba(255, 165, 0, 0.5);
      }

      #pw-submit {
        padding: 10px 20px;
        background-color: orange;
        border: none;
        border-radius: 4px;
        color: white;
        cursor: pointer;
        font-weight: bold;
        transition: background-color 0.2s ease;
      }

      #pw-submit:hover {
        background-color: darkorange;
      }
    </style>

    <div style="background: white; padding: 20px; border-radius: 8px; text-align: center; max-width: 300px;">
      <h2>🔐 Nhập mật khẩu</h2>
      <input id="pw-input" type="password" />
      <br/><br/>
      <button id="pw-submit">Xác nhận</button>
    </div>
  `;

  document.body.appendChild(modal);
  modal.querySelector('#pw-input').focus();

  modal.querySelector('#pw-submit').addEventListener('click', () => {
    const value = modal.querySelector('#pw-input').value;
    document.body.removeChild(modal);
    onSubmit(value);
  });

  modal.querySelector('#pw-input').addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      modal.querySelector('#pw-submit').click();
    }
  });
}

function validateDevToolsAccess() {
  const open = isDevToolsOpen();
  const passed = sessionStorage.getItem('devtools_passed') === 'true';

  if (open && !passed) {
    showPasswordModal((input) => {
      if (input === expectedPassword) {
        sessionStorage.setItem('devtools_passed', 'true');
      } else {
        document.body.innerHTML = `<h1 style="color:red; text-align:center; margin-top:20%">🚫 Truy cập bị khóa</h1>`;
      }
    });
  }
}

function watchDevToolsLive() {
  const loop = () => {
    validateDevToolsAccess();
    requestAnimationFrame(loop);
  };
  requestAnimationFrame(loop);
}

window.addEventListener('resize', validateDevToolsAccess);

function renderApp() {
  import('./App.jsx').then(({ default: App }) => {
    import('react').then(React =>
      import('react-dom/client').then(ReactDOM => {
        import('./contexts/AuthContext.jsx').then(({ AuthProvider }) => {
          import('./contexts/UserContext.jsx').then(({ UserProvider }) => {
            const root = ReactDOM.createRoot(document.getElementById('root'));
            root.render(
              React.createElement(React.StrictMode, null, 
                React.createElement(AuthProvider, null,
                  React.createElement(UserProvider, null, React.createElement(App))
                )
              )
            );
            watchDevToolsLive();
          });
        });
      })
    );
  });
}

// Kiểm tra em_token khi app khởi động
async function checkTokenValidity() {
  // Skip kiểm tra token khi dev local
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    console.log('Local development - skipping token check');
    return true;
  }
  
  // Skip kiểm tra token khi đang chạy netlify dev
  if (window.location.port === '8888') {
    console.log('Netlify dev - skipping token check');
    return true;
  }
  
  try {
    const response = await fetch('/.netlify/functions/getToken', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({})
    });
    
    if (response.status === 404) {
      const errorData = await response.json();
      alert(errorData.error); // "Phiên đăng nhập đã hết hạn"
      window.location.href = errorData.redirect || 'https://app.estatemanner.com/login';
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Token check failed:', error);
    return true; // Nếu lỗi network, vẫn cho phép app chạy
  }
}

function initApp() {
  const passed = sessionStorage.getItem('devtools_passed') === 'true';
  if (isDevToolsOpen() && !passed) {
    showPasswordModal((input) => {
      if (input === expectedPassword) {
        sessionStorage.setItem('devtools_passed', 'true');
        renderApp();
      } else {
        document.body.innerHTML = `<h1 style="color:red; text-align:center; margin-top:20%">🚫 Truy cập bị khóa</h1>`;
      }
    });
  } else {
    renderApp();
  }
}

initApp();
